import { Translate } from '@dreryk/react-common';
import { StyledFlex, Text } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../translations';

import { Prices } from './totalPrice.types';
import { useTotalPrice } from './totalPrice.utils';

const t = visitSettlementTranslationKeys.shared.totalPrice;

type TotalPriceTextProps = {
   readonly prices: Prices;
};

export const TotalPriceText = (props: TotalPriceTextProps): JSX.Element => {
   const totalPrice = useTotalPrice(props.prices);

   return (
      <StyledFlex gap={'18px'} justifyContent={'end'}>
         <Text as={'strong'} testId={'label'}>
            <Translate>{t.label}</Translate>
            {': '}
         </Text>
         <Text as={'strong'} testId={'price'} whiteSpaces={'nowrap'}>
            {totalPrice}
         </Text>
      </StyledFlex>
   );
};
